/**
 * Helper to extract and format employer / company name from URL search parameters.
 * Supports query params like:
 * ?employer=Boeing
 * ?company=Caterpillar
 * ?org=United+Airlines
 * ?name=AbbVie
 * ?business=Walgreens
 */
export function getEmployerNameFromParams(
  searchParams: URLSearchParams,
): string | null {
  const raw =
    searchParams.get("employer") ||
    searchParams.get("company") ||
    searchParams.get("org") ||
    searchParams.get("organization") ||
    searchParams.get("business") ||
    searchParams.get("employer_name");

  if (!raw) return null;

  const cleaned = raw.trim();
  if (cleaned.length === 0 || cleaned.length > 80) return null;

  // Basic sanitization — remove scripts or unusual punctuation
  const sanitized = cleaned.replace(/[<>{}[\]\\]/g, "");
  return sanitized.length > 0 ? sanitized : null;
}
